import React, { FunctionComponent, useEffect, useState } from 'react';
import { mainMediaMobile } from '../../../../utils';
import { useStepper } from '../../../../hooks';
import useMediaQuery from '../../../../hooks/use-media';
import classNames from '../../../../utils/classnames';
import { AccordionButton, Box } from '@chakra-ui/react';
import { SharedIconArrowDown, SharedIconCheck, SharedIconStripe } from '../../icons';

export const StepperHeader: FunctionComponent<{
  id: number;
  title: string | undefined;
  completedText?: string;
  onClose?: () => void;
}> = ({ id, title, completedText, onClose }) => {
  const [headerRef, setHeaderRef] = useState<HTMLDivElement | null>(null);
  const { steps } = useStepper();
  const { isActive, isTouched, isValid } = steps[id];
  const { setCurrentStep, setStepActive, currentStep } = useStepper();
  const isMobile = useMediaQuery(mainMediaMobile);
  const isDisabled = !isActive && !isTouched;
  const lastStep = currentStep === steps.length - 1;

  const accordionButtonClasses = classNames({
    'cursor-pointer': !isDisabled
  });

  const titleClasses = classNames(`grow text-left`, {
    'text-gray-500': isActive
  });

  useEffect(() => {
    if (isActive && currentStep && currentStep > 0) {
      // console.log('currentStep', currentStep, isActive);
      setTimeout(() => {
        headerRef?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'start'
        });
      }, 200);
    }
  }, [isActive, isMobile]);

  return (
    <div ref={setHeaderRef} className={`scroll-mt-80 md:scroll-mt-60`}>
      <AccordionButton
        p={0}
        width={'100%'}
        className={accordionButtonClasses}
        onClick={() => {
          if (!isMobile && !isDisabled) {
            // Don't allow to close a step if it is the last step
            if (id === steps.length - 1) return;

            const stepToOpen = currentStep === id ? id + 1 : id;
            const { isValid: isValidStepToOpen } = steps[stepToOpen];

            //console.log(id, currentStep, steps.length - 1);
            //console.log('stepToOpen', isValidStepToOpen, stepToOpen);
            //console.log('currentStep', isValid, currentStep);

            // if the step to open and current step is invalid, don't allow to open the next step
            if (!isValidStepToOpen && !isValid) return;

            steps.forEach((step, index) => {
              setStepActive(index, false);
            });

            setStepActive(stepToOpen, !isActive);
            setCurrentStep(stepToOpen);
            onClose && onClose();
          }
        }}>
        <Box className={`flex grow justify-between w-full items-center min-h-[60px] md:px-4`}>
          <Box className={titleClasses}>
            {isValid && <SharedIconCheck mr={`2`} color={`green.500`}></SharedIconCheck>}
            {title}
          </Box>
          {completedText && <Box className={`mr-4`}>{completedText}</Box>}

          {(!isDisabled || isValid) && !isMobile && (
            <Box
              className={`rounded-full w-[3.2rem] h-[3.2rem] items-center flex justify-center ${
                isActive && !lastStep && isValid ? 'bg-blue-500' : 'bg-gray-300'
              }`}>
              {!isActive ? (
                <SharedIconArrowDown color={`blue.500`} boxSize={6} />
              ) : (
                <SharedIconStripe color={`white`} boxSize={6} />
              )}
            </Box>
          )}
        </Box>
      </AccordionButton>
    </div>
  );
};
